import skillsGuide from "./Guides/skillsGuide";
import GuideRenderer from "../../components/wikiComponents/GuideRenderer";

const SkillsGuide = () => {
  return <GuideRenderer url="skills" guideData={skillsGuide} />;
};

export default SkillsGuide;
